<script lang="ts" setup>
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useAppBridgeStore } from '@nora-monorepo/ui-shared';

import { handleGeoLinkClick } from '#nora-chat-ui/directives/linkify/clickLinkHandlers';
import { urlGuardClickHandler } from '#nora-chat-ui/directives/url-guard/url-guard.directive';
import type { MessageState } from '#nora-chat-ui/states';
import { renderMessageMarkdown } from '#nora-chat-ui/utils/message-markdown';

const props = defineProps<MessageContentProps>();

const { t } = useI18n();
const appBridgeStore = useAppBridgeStore();

interface MessageContentProps {
  messageState: MessageState;
  isMine: boolean;
  operationId?: string | null;
}

const { messageState, isMine, operationId } = toRefs(props);

const message = computed(() => {
  if (messageState.value.message.deletedAt) {
    return t('message.deleted');
  }

  if (!messageState.value.message.message) {
    return '';
  }

  return renderMessageMarkdown(messageState.value.message.message);
});

function onMessageContentClick(event: MouseEvent): void {
  if (event.target instanceof Element && event.target.closest('a')) {
    event.stopPropagation();
  }

  const { latitude, longitude } = handleGeoLinkClick(event) ?? {};
  if (latitude === undefined || longitude === undefined) {
    if (event.target instanceof HTMLElement) {
      urlGuardClickHandler(event.target, event);
    }

    return;
  }

  appBridgeStore.nora.actions.goToCoordinates(latitude, longitude, undefined, operationId.value);
}
</script>

<template>
  <div>
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-linkify
      class="markdown"
      :class="{ mine: isMine }"
      @click="onMessageContentClick"
      v-html="message"
    />
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>
